import { render } from "./ChatView.vue?vue&type=template&id=329b6ae5&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"

import "./ChatView.vue?vue&type=style&index=0&id=329b6ae5&lang=scss&scoped=true"
import "./ChatView.vue?vue&type=style&index=1&id=329b6ae5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329b6ae5"]])

export default __exports__